<template>
    <span>
        <el-button type="text" size="small" @click="dialogVisible = true">查看占用库容客户</el-button>
        <el-dialog title="占用库容客户" :visible.sync="dialogVisible">
            <el-row class="searchSection">
                <SearchForm
                    :params="searcheModel"
                    :fields="fields"
                    :cache_field="'search_config_' + active_name + '_' + this.$route.path"
                    :is_config="false"
                    @search="submitSearch"
                    @reset="resetForm"
                    :key="search_form_key">
                </SearchForm>
            </el-row>
            <el-table
                :data="list"
                border
                height="450"
                v-loading="loading">
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="name" label="客户名称"></el-table-column>
                <el-table-column prop="level_name" label="级别"></el-table-column>
                <el-table-column prop="district_names" label="所在地区"></el-table-column>
                <el-table-column prop="username" label="业务员"></el-table-column>
                <el-table-column prop="branch_name" label="部门"></el-table-column>
                <el-table-column label="操作"  fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="handleView(scope.row)" type="text"  size="small">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
        </el-dialog>
    </span>
</template>
<script>
import CustomerService from "~/services/customer";
import MyPagination from "~/widgets/MyPagination.vue";
import SearchForm from "~/widgets/SearchForm.vue";
export default {
    name: "MyBindList",
    props: {
        params: {
            type: Object,
            required: false,
            value: function () {
                return {};
            }
        },
        customerId: "",
    },
    components: {
        MyPagination,
        SearchForm
    },
    
    data() {
        return {
            list: [],
            loading: false,
            searcheModel: {},
            dialogVisible: false,
            linkPage: null,
            fields: [],
            search_form_key: 100,
            active_name: 'bind-customer',
            levels: CustomerService.getLevels(true),
        }
    },

    created: function () {
        this.resetForm();
    },
    
    methods: {
        // 筛选查询
        submitSearch(params = null) {
            if(params){
                this.searcheModel = params;
            }
            params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            //请求侧边栏地区树
            this.getList(params);
        },

        //重置按钮
        resetForm() {
            this.fields = [
                {field: 'base', label: '基础信息筛选条件', children: [
                    {field: 'name', label: '客户名称', type: 'components', ref: 'customer', components: 'CustomerSelect', change: 'changeObjValue'},
                    {field: 'district_id', label: '所在地区', type: 'components', ref: 'district', components: 'DistrictCascader', change: 'changeDistrict'},
                    {field: 'level', label: '客户级别', type: 'select', list: Object.keys(this.levels).map(key => ({ value: key, label: this.levels[key] }))},
                ]},
            ];
            this.searcheModel = {
                province_id: 0,
                city_id: 0,
                district_id: 0,
            };
            this.list = [];
            this.search_form_key ++;
            this.submitSearch();
        },

        //获取列表
        getList(params = {}) {
            // loading 动画
            this.loading = true;
            CustomerService.getMyUnsold(params)
            .then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                if (res._meta) {
                    this.linkPage = res._meta;
                }
                this.loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        handleSizeChange(newSize) {
            // 处理每页条目数变化事件
            this.searcheModel['perPage'] = newSize;
            this.submitSearch();
        },

        handleCurrentChange(newPage) {
            // 处理当前页码变化事件
            this.searcheModel['page'] = newPage;
            this.submitSearch();
        },

        handleView(row) {
            let routeData = this.$router.resolve({
                path: "/customers/view",
                query: { id: row.id },
            });
            window.open(routeData.href, '_blank');
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/customer/dialog/MyBindList.vue